import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import {
    courseFeesReducer,
    currentSemesterReducer,
    DepartmentListReducer,
    FacultyListReducer,
    GeneralReducer,
    HostelDetailsReducer,
    loginDetailsReducer,
    LoginDetailsReducer, minAmountReducer,
    otherFeesReducer, paymentHistoryReducer,
    PermissionDetailsReducer,
    PersonalInfoDetailsReducer, scholarshipReducer,
    walletReducer,
} from "./detailsReducer";

import storage from "redux-persist/lib/storage";
import {projectshortCode} from "../resources/constants";

const rootReducer = combineReducers({
    LoginDetails: LoginDetailsReducer,
    paymentLoginDetails: loginDetailsReducer,
    PermissionDetails: PermissionDetailsReducer,
    FacultyList: FacultyListReducer,
    DepartmentList: DepartmentListReducer,
    currentSemester: currentSemesterReducer,
    general: GeneralReducer,
    HostelDetails: HostelDetailsReducer,
    PersonalInfo: PersonalInfoDetailsReducer,
    walletData: walletReducer,
    courseFeeData: courseFeesReducer,
    otherFeeData: otherFeesReducer,
    minAmountData: minAmountReducer,
    scholarshipData: scholarshipReducer,
    paymentHistoryData: paymentHistoryReducer
});

const persistConfig = {
    key: projectshortCode.toLowerCase()+'_student_portal',
    storage,
};

export default persistReducer(persistConfig, rootReducer);